<template>
  <div class="fts-mobile-solution">
    <fts-solution
      :solution-id.sync="formData.solutionId"
      :a-i-mode.sync="formData.aIMode"
      class="mobile-solution"
      v-if="ready"
    />
  </div>
</template>

<script>
import FTSSolution from '../elements/solution/FTSSolution';
import { authorizationStore } from '../store/authorizationStore';

export default {
  components: {
    'fts-solution': FTSSolution
  },
  data: () => ({
    ready: false,
    formData: {}
  }),
  mounted() {
    if (authorizationStore.getters.isDevelopment) {
      this.ready = true;
    } else {
      this.$router.replace({ name: 'dashboard' });
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-mobile-solution {
  .mobile-solution {
    width: 1024px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>